document.addEventListener('DOMContentLoaded', () => {
    
    const el = document.querySelector('.js-topbar');
    const action = () => {
        let scroll_pos = window.pageYOffset || window.scrollY;
        let newsbar = document.querySelector('.js-newsbar');
        let newsbarHeight = 0;

        if (newsbar) {
          newsbarHeight = newsbar.clientHeight;
        } 

        scroll_pos > newsbarHeight ? el.classList.add('is-narrow') : el.classList.remove('is-narrow');
    }

    el ? window.addEventListener('scroll', action) : false;

}, false);
